import React, { useEffect } from 'react'
import { useMutation } from 'react-query'
import { useMachine } from '@xstate/react'

import { FileUploaderMachineActor } from '../machines/FileUploaderMachine/FileUploaderMachine'
import { fileUploadersMachine } from '../machines/FileUploadersMachine/FileUploadersMachine'
import { useFileUploadConfigServices } from './services/useFileUploadConfigServices'

type fileUploaderProviderState = {
  fileUploadersMachine?
  spawnNewFileUploader?: () => FileUploaderMachineActor
  getAwsCredentials?: () => void
}

interface FileUploaderProps {
  children
}

const FileUploaderContext = React.createContext<fileUploaderProviderState>({})

export const useFileUploader = () => {
  const context = React.useContext(FileUploaderContext)

  if (!context)
    throw new Error('Expected to be wrapped in a FileUploaderProvider')

  return context
}

export const FileUploaderProvider = (props: FileUploaderProps) => {
  const { fileUploadConfigServices } = useFileUploadConfigServices()

  const { mutateAsync: getFileUploadConfig } = useMutation(() =>
    fileUploadConfigServices.getFileUploadConfig()
  )

  const fileUploader = useMachine(
    fileUploadersMachine.withConfig({
      services: {
        getAWSCredentials: () => getFileUploadConfig()
      }
    }),
    { devTools: true }
  )

  const [state, send] = fileUploader

  const getAwsCredentials = () => {
    send({ type: 'GET_AWS_CREDENTIALS' })
  }

  return (
    <FileUploaderContext.Provider
      value={{
        fileUploadersMachine: fileUploader,
        getAwsCredentials
      }}
    >
      {props.children}
    </FileUploaderContext.Provider>
  )
}
